import request from "./request";
export function validatePassword(data) {
  return request({
    url: process.env.VUE_APP_PROXY_API + '/user/checkpwd',
    method: 'post',
    data: data
  });
}